<script setup>
  import { onMounted } from "vue";
  import { useHead } from "@unhead/vue";

  useHead({
    title: "Digital Frontier | 404",
  });

  onMounted(() => {
    window.scrollTo(0, 0);
  });
</script>

<template>
  <Teleport to="#error-holder">
    <a
      href="/"
      class="d-block mt-16"
    >
      <img
        src="@/assets/error-transparent.gif"
        alt="404"
        class="w-full object-cover"
      />
    </a>
  </Teleport>
</template>

<style>
  #error-holder img {
    width: 100%;
    object-fit: cover;
  }
</style>
